import React from "react";
import { usePlacesWidget } from "react-google-autocomplete";

interface AutocompleteInputProps {
  onAddressSelect: (address: string, lat: number, lng: number) => void;
}

const allowedCountries = ["US", "CA"]; // Allowed country codes (USA & Canada)

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({
  onAddressSelect,
}) => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: apiKey,
    options: {
      types: ["geocode"], // Restrict to addresses
    },
    onPlaceSelected: (place: google.maps.places.PlaceResult) => {
      if (place.geometry) {
        const { lat, lng } = place.geometry.location!;
        const address = place.formatted_address || "";

        // Extract country code from address components
        const countryComponent = place.address_components?.find((comp) =>
          comp.types.includes("country")
        );
        const countryCode = countryComponent?.short_name || "";

        // Check if country is allowed
        if (allowedCountries.includes(countryCode)) {
          onAddressSelect(address, lat(), lng());
        } else {
          console.warn(
            "Selected location is not in allowed countries:",
            countryCode
          );
        }
      } else {
        console.error("Place geometry is not available");
      }
    },
  });

  return (
    <div className="relative w-full">
      <input
        ref={ref}
        type="text"
        placeholder="Event Address"
        className="w-full px-9 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
      />
    </div>
  );
};

export default AutocompleteInput;
